import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  min-height: 200px;
  z-index: 72;

  table {
    border-collapse: collapse;
    border-spacing: 0;
    color: inherit;
    width: inherit;
    text-align: inherit;
    font: unset;
  }

  th,
  td {
    padding: inherit;
    border-bottom: inherit;
  }

  th {
    font: unset;
  }
  height: ${props => (props.isExpanded ? 'auto' : '330px')};
  overflow: hidden;
  .ccs-cc-inline-feature-description-container {
    z-index: 10;
  }
`
// z-index 10 override third party style conflict

const ButtonWrapper = styled.div`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.442642) 24.12%,
    rgba(255, 255, 255, 0.737734) 51.87%,
    rgba(255, 255, 255, 0.92) 75.89%,
    #ffffff 100%
  );
  bottom: 0;
  display: ${props => (props.isExpanded ? 'none' : 'flex')};
  justify-content: center;
  margin-bottom: 1px;
  padding: 100px 20px 20px;
  position: absolute;
  width: calc(100% - 30px);
  z-index: 74;
`

const Header = styled.div`
  color: ${props => props.theme.color.palette['brand-1']};
`

export { Container, ButtonWrapper, Header }
